import { addBreadcrumb, captureMessage } from '@repo/error';

interface Params {
  isPaymentStatusKnown: boolean;
  paymentStatus: string;
  paymentId: string;
}

export const trackPayNowReturn = ({ isPaymentStatusKnown, paymentStatus, paymentId }: Params): void => {
  if (!isPaymentStatusKnown || !paymentStatus) {
    captureMessage('Unexpected PayNow paymentStatus', {
      level: 'warning',
      extra: {
        isPaymentStatusEmpty: !paymentStatus,
        paymentStatus,
        paymentId,
      },
    });
    return;
  }

  addBreadcrumb({
    category: 'payment',
    message: `PayNow returned status=${paymentStatus}`,
    level: 'info',
    data: { paymentId },
  });
};
